import Loader from "@/Components/Common/Loader";
import SignUp from "@/Pages/Auth/SignUp";
import Layout from "@/Pages/Layout";
import ProductWishList from "@/Pages/ProductWishList/ProductWishList";
import { Suspense, lazy } from "react";
const Home = lazy(() => import("../Pages/Home/Home"));
const NotFound = lazy(() => import("../Pages/NotFound/NotFound"));
const BuyPorduct = lazy(() => import("../Pages/Products/BuyPorduct"));
const ProductDetails = lazy(() => import("../Pages/Products/ProductDetails"));
const Login = lazy(() => import("../Pages/Auth/Login"));
const CheckOutDetails = lazy(
  () => import("../Pages/Dashboard/Buyer/CheckOutDetails"),
);
const EcommerceStoreOrder = lazy(
  () => import("../Pages/Dashboard/Seller/My_Orders"),
);
const EcommerceSettings = lazy(
  () => import("../Pages/Dashboard/Seller/EcommerceSettings"),
);
const Ecommerce = lazy(() => import("../Pages/Dashboard/Seller/Store"));
const Search = lazy(() => import("../Pages/Search"));
const StoreMain = lazy(() => import("../Pages/StoreMain"));
const OrderHistory = lazy(
  () => import("../Pages/Dashboard/Buyer/OrderHistory"),
);
const Addresses = lazy(() => import("../Pages/Dashboard/Buyer/Addresses"));
const TrackOrders = lazy(() => import("../Pages/FooterPages/TrackOrders"));
const ReturnsAndRefunds = lazy(() => import("../Pages/FooterPages/ReturnsAndRefunds"));
const ShippingInformation = lazy(() => import("../Pages/FooterPages/ShippingInformation"));
const ContactSupport = lazy(() => import("../Pages/FooterPages/ContactSupport"));
const SellOnInstaPay = lazy(() => import("../Pages/FooterPages/SellOnInstaPay"));
const AffiliateProgram = lazy(() => import("../Pages/FooterPages/AffiliateProgram"));
const AdvertiseBrand = lazy(() => import("../Pages/FooterPages/AdvertiseBrand"));
const PartnerStores = lazy(() => import("../Pages/FooterPages/PartnerStores"));
const SupplierPortal = lazy(() => import("../Pages/FooterPages/SupplierPortal"));
const PaymentStatus = lazy(() => import("../Pages/PaymentStatus"));

export const approuter = [
  {
    path: "/",
    element: (
      <Suspense fallback={<Loader />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<Loader />}>
        <NotFound />
      </Suspense>
    ),
  },
  {
    path: "/dashboard/",
    element: (
      <Suspense fallback={<Loader />}>
        <Layout />{" "}
      </Suspense>
    ),
    children: [
      {
        path: "seller",
        element: (
          <Suspense fallback={<Loader />}>
            <Ecommerce />
          </Suspense>
        ),
      },
      {
        path: "seller/products",
        element: (
          <Suspense fallback={<Loader />}>
            <Ecommerce />
          </Suspense>
        ),
      },
      {
        path: "seller/orders",
        element: (
          <Suspense fallback={<Loader />}>
            <EcommerceStoreOrder />
          </Suspense>
        ),
      },

      {
        path: "seller/settings",
        element: (
          <Suspense fallback={<Loader />}>
            <EcommerceSettings />
          </Suspense>
        ),
      },
      {
        path: "seller/join",
        element: (
          <Suspense fallback={<Loader />}>
            <EcommerceSettings />
          </Suspense>
        ),
      },
      {
        path: "buyer",
        element: (
          <Suspense fallback={<Loader />}>
            <OrderHistory />
          </Suspense>
        ),
      },
      {
        path: "buyer/order-history",
        element: (
          <Suspense fallback={<Loader />}>
            <OrderHistory />
          </Suspense>
        ),
      },
      {
        path: "buyer/checkout-details/:id",
        element: (
          <Suspense fallback={<Loader />}>
            <CheckOutDetails />
          </Suspense>
        ),
      },

      {
        path: "buyer/manage-addresses",
        element: (
          <Suspense fallback={<Loader />}>
            <Addresses />
          </Suspense>
        ),
      },
    ],
  },

  {
    path: "/buy-product",
    element: (
      <Suspense fallback={<Loader />}>
        <BuyPorduct />
      </Suspense>
    ),
  },

  {
    path: "/payment-status/:status/:paymentMethod",
    element: (
      <Suspense fallback={<Loader />}>
        <PaymentStatus />
      </Suspense>
    ),
  },

  {
    path: "/details/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <ProductDetails />
      </Suspense>
    ),
  },
  {
    path: "/search",
    element: (
      <Suspense fallback={<Loader />}>
        <Search />
      </Suspense>
    ),
  },
  {
    path: "/product-wishlist",
    element: (
      <Suspense fallback={<Loader />}>
        <ProductWishList />
      </Suspense>
    ),
  },
  {
    path: "/store/:id",
    element: (
      <Suspense fallback={<Loader />}>
        <StoreMain />{" "}
      </Suspense>
    ),
  },
  {
    path: "/login",
    element: (
      <Suspense fallback={<Loader />}>
        <Login />{" "}
      </Suspense>
    ),
  },
  {
    path: "/signup",
    element: (
      <Suspense fallback={<Loader />}>
        <SignUp />{" "}
      </Suspense>
    ),
  },
  {
    path: "/trackOrders",
    element: (
      <Suspense fallback={<Loader />}>
        <TrackOrders />{" "}
      </Suspense>
    ),
  },
  {
    path: "/returnsAndRefunds",
    element: (
      <Suspense fallback={<Loader />}>
        <ReturnsAndRefunds />{" "}
      </Suspense>
    ),
  },
  {
    path: "/shippingInformation",
    element: (
      <Suspense fallback={<Loader />}>
        <ShippingInformation />{" "}
      </Suspense>
    ),
  },
  {
    path: "/contactSupport",
    element: (
      <Suspense fallback={<Loader />}>
        <ContactSupport />{" "}
      </Suspense>
    ),
  },
  {
    path: "/sellOnInstaPay",
    element: (
      <Suspense fallback={<Loader />}>
        <SellOnInstaPay />{" "}
      </Suspense>
    ),
  },
  {
    path: "/affiliateProgram",
    element: (
      <Suspense fallback={<Loader />}>
        <AffiliateProgram />{" "}
      </Suspense>
    ),
  },
  {
    path: "/advertiseBrand",
    element: (
      <Suspense fallback={<Loader />}>
        <AdvertiseBrand />{" "}
      </Suspense>
    ),
  },
  {
    path: "/partnerStores",
    element: (
      <Suspense fallback={<Loader />}>
        <PartnerStores />{" "}
      </Suspense>
    ),
  },
  {
    path: "/supplierPortal",
    element: (
      <Suspense fallback={<Loader />}>
        <SupplierPortal />{" "}
      </Suspense>
    ),
  },
];
